import { IconButton, Tooltip } from "@mui/material";
import { LuFilter } from "react-icons/lu";

const ColumnVisibilityButton = ({ label = "Column Visibility", onClick = () => {}, disabled = false }) => {
  return (
    <Tooltip title={label}>
      <span>
        <IconButton onClick={onClick} disabled={disabled} variant="Light Green">
          <LuFilter />
        </IconButton>
      </span>
    </Tooltip>
  );
};
export default ColumnVisibilityButton;
